import { Component, OnInit } from '@angular/core';
import { AssetService } from '../../../../services/asset.service';

@Component({
    selector: 'app-copy-text-hud',
    templateUrl: './copy-text-hud.component.html',
    styleUrls: ['./copy-text-hud.component.scss'],
    standalone: true
})
export class CopyTextHudComponent implements OnInit {
    imgSrc: string;

    constructor(public assetService: AssetService) {
    }

    ngOnInit(): void {
        this.imgSrc = this.assetService.getUrl('icon-buchlink-weiss-einzelseite.png');
    }
}
